$(document).on('shopify:section:load', function () {
    refreshCart(true);
    refreshMainCart();

    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('cart') && urlParams.get('cart') === 'open') {
        openCart();
    }

    if ($('.cart-ymal .owl-carousel').length) {
        let owl_accessory = $('.cart-ymal .owl-carousel').owlCarousel({
            items: 1,
            nav: false,
            dots: false,
            smartSpeed: 800,
            margin: 10,
            stagePadding: 60,
            responsive: {
                0: {
                    stagePadding: 0
                },
                414: {
                    stagePadding: 30
                },
                1280: {
                    stagePadding: 60
                }
            }
        });
    
        $(".cart-ymal .slide-prev").on('click', function() {
            owl_accessory.trigger('prev.owl.carousel');
        });
        $(".cart-ymal .slide-next").on('click', function() {
            owl_accessory.trigger('next.owl.carousel');
        });
    }
});

$(document).ready(function () {
    refreshCart(true);
    refreshMainCart();

    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('cart') && urlParams.get('cart') === 'open') {
        openCart();
    }

    if ($('.cart-ymal .owl-carousel').length) {
        let owl_accessory = $('.cart-ymal .owl-carousel').owlCarousel({
            items: 1,
            nav: false,
            dots: false,
            smartSpeed: 800,
            margin: 10,
            stagePadding: 60,
            responsive: {
                0: {
                    stagePadding: 0
                },
                414: {
                    stagePadding: 30
                },
                1280: {
                    stagePadding: 60
                }
            }
        });
    
        $(".cart-ymal .slide-prev").on('click', function() {
            owl_accessory.trigger('prev.owl.carousel');
        });
        $(".cart-ymal .slide-next").on('click', function() {
            owl_accessory.trigger('next.owl.carousel');
        });
    }
});

// open cart on navigation
$('.header .icon-cart').on('click', function() {
    openCart();
});

function openCart() {
    $('#popup-cart').css('display', 'flex').hide().fadeIn();
    $('body').css('overflow-y', 'hidden');

    if ($('.popup-order').length && $('.popup-order').css('display') == 'flex')
        $('.popup-order').fadeOut();
}

// close cart
$('#popup-cart .cart-close').on('click', function() {
    closeCart();
});

function closeCart() {
    $('#popup-cart').fadeOut();
    $('body').css('overflow-y', 'visible');
}

// preventing scroll
function preventScroll(event) {
    event.preventDefault();
}

// form add to cart

$(document).on('submit', '.atc-form', function (event) {
    event.preventDefault();
    let form = $(this);
    let formData = form.serialize();

    form.find('.btn-atc span').css('visibility', 'hidden');
    form.find('.btn-atc .atc-overlay').css('display', 'flex');

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function (response) {
            refreshCart();
            refreshMainCart();
            openCart();
          
            form.find('.btn-atc span').css('visibility', 'visible');
            form.find('.btn-atc .atc-overlay').css('display', 'none');
        },
        error: function (xhr, status, error) {
            console.error('Error adding product to cart:', error);
            form.find('.btn-atc span').css('visibility', 'visible');
            form.find('.btn-atc .atc-overlay').css('display', 'none');
        }
    });
});

// accessory add to cart
$('.accessory-form').on('submit', function (event) {
    event.preventDefault();
    let formData = $(this).serialize();

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function (response) {
            refreshCart();
            refreshMainCart();
            openCart();
        },
        error: function (xhr, status, error) {
            console.error('Error adding product to cart:', error);
        }
    });
});


// ymal add to cart
$('.ymal-form').on('submit', function (event) {
    event.preventDefault();
    let formData = $(this).serialize();

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function (response) {
            refreshCart();
            refreshMainCart();
        },
        error: function (xhr, status, error) {
            console.error('Error adding product to cart:', error);
        }
    });
});

// item remove to cart
$(document).on('click', '.product-remove', function(event) {
    $('#popup-cart .el-overlay').show();
    event.preventDefault();

    let removeUrl = $(this).attr('href'); 

    $.ajax({
        type: 'POST',
        url: removeUrl,
        success: function() {
          
            refreshCart();
            refreshMainCart();
        },
        error: function(xhr, status, error) {
            console.error('Error removing item:', error);
        }
    });
});

// update quantity
var qtyTimer;
function updateQty(updateUrl) {
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(function() {
        $.ajax({
            type: 'POST',
            url: updateUrl,
            success: function() {
                refreshCart();
                refreshMainCart();
            },
            error: function(xhr, status, error) {
                refreshCart();
                refreshMainCart();

                console.error('Error updating item:', error);
            }
        });
    }, 100);
}
$(document).on('click', '#popup-cart .less_qty, .main-cart .less_qty', function() {
  
    let key = $(this).data('key');
    let qty = $(`#popup-cart .qty[data-key="${key}"]`).val();

    if (qty >= 0) {
        qty--;

        let updateUrl = `/cart/change?id=${key}&quantity=${qty}`;

        $(`#popup-cart .qty[data-key="${key}"]`).val(qty);
        
        if ($('.main-cart').length) {
            $(`.main-cart .qty[data-key="${key}"]`).val(qty);
        }

        updateQty(updateUrl);
    }
});
$(document).on('click', '#popup-cart .add_qty, .main-cart .add_qty', function() {
    let key = $(this).data('key');
    let qty = $(`#popup-cart .qty[data-key="${key}"]`).val();

    if (qty < 100) {
        qty++;

        let updateUrl = `/cart/change?id=${key}&quantity=${qty}`;
        
        $(`#popup-cart .qty[data-key="${key}"]`).val(qty);
        $(`.main-cart .qty[data-key="${key}"]`).val(qty);

        updateQty(updateUrl);
    }
});

// refresh cart
function refreshCart(isPageLoad = false) {
    
    $('#popup-cart .el-overlay').show();
    $('#popup-cart .option').css('right', '-100%');
    $('#popup-cart .discount-wrapper .discount-message').hide();
    $('#popup-cart .discount-form input').val('');

    $.ajax({
        type: 'GET',
        url: '/',
        dataType: 'html',
        success: function(cartHtml) {
            let newCartItems = $(cartHtml).find('.cart-body').html();
            $('#popup-cart .cart-body').html(newCartItems);

            let newCartTotal = $(cartHtml).find('.cart-total-price').html();
            $('#popup-cart .cart-total-price').html(newCartTotal);

            let newCartSaving = $(cartHtml).find('.total-save').html();
            $('#popup-cart .total-save').html(newCartSaving);

            let discountApplied = $(cartHtml).find('.discount-applied').html();
            $('#popup-cart .discount-applied').html(discountApplied);

            let discountCode = $(cartHtml).find('.discount-code-wrapper').html();
            $('#popup-cart .discount-code-wrapper').html(discountCode);

          
            let totalPrice = $(cartHtml).find('.total-price').html();
            $('#popup-cart .total-price').html(totalPrice);

            if ($(cartHtml).find('.cart-body').find('.product-cart').length == 0) {
                $('#popup-cart .cart-checkout a').addClass('disabled');
                $('.header .icon-cart .dot').hide();
                
                if (!isPageLoad) {
                    fetch(`${window.location.origin}/checkout?discount=CLEAR`);
                }
            }
            else {
                $('#popup-cart .cart-checkout a').removeClass('disabled');
                $('.header .icon-cart .dot')
                  .css('display', 'flex')
                  .text($(cartHtml).find('.header .header-wrapper .icon-cart .dot').text());
                
            }
                
            $('#popup-cart .el-overlay').hide();
        },
        error: function(xhr, status, error) {
            console.error('Error fetching cart data:', error);
            $('#popup-cart .el-overlay').hide();
        }
    });
}

// refresh main cart
function refreshMainCart() {
    if ($('.main-cart').length) {
        $('.main-cart .el-overlay').show();

        $(document).find('.main-cart .discount-form input').val('');

        $.ajax({
            type: 'GET',
            url: `${window.location.origin}/cart`,
            dataType: 'html',
            success: function(mainHtml) {
                let newHtml = $(mainHtml).find('.main-cart .main-cart-data').html();
                $('.main-cart .main-cart-data').html(newHtml);

                $('.main-cart .el-overlay').hide();
            },
            error: function(xhr, status, error) {
                console.error('Error fetching cart data:', error);
                $('.main-cart .el-overlay').hide();
            }
        });
    }
}

// close if away
$('#popup-cart .overlay').on('click', function () {
    closeCart();
});

//apply discount code in popup
$('.discount-form button').on('click', function() {
    let code = $('#popup-cart .discount-form input').val().trim();

    if (code) {
        $('#popup-cart .el-overlay').show();
        $('#popup-cart .discount-wrapper .discount-message').hide();
    
        let discountApplyUrl = `${window.location.origin}/discount/${encodeURIComponent(code)}?redirect=/cart/`;
    
        fetch(discountApplyUrl, {
            method: "GET",
            credentials: "include"
        })
        .then(() => {
            return fetch(`${window.location.origin}/cart.json`, { method: "GET" });
        })
        .then(response => response.json())
        .then(cartData => {
            let discountTitles = cartData.items
                                .map(item => item.discounts.map(discount => discount.title.toLowerCase()))
                                .flat()
                                .filter(title => title);
            
            if (discountTitles.length > 0) {
                if (discountTitles.includes(code.toLowerCase())) {
                    refreshCart();
                    refreshMainCart();
                } 
                else {
                    $('#popup-cart .discount-wrapper .discount-message').show();
                    $('#popup-cart .el-overlay').hide();
                }
            } 
            else {
                $('#popup-cart .discount-wrapper .discount-message').show();
                $('#popup-cart .el-overlay').hide();
            }
        })
        .catch(() => {
            $('#popup-cart .discount-wrapper .discount-message').show();
            $('#popup-cart .el-overlay').hide();
        });
    }
    
});

//apply discount code in main
$(document).on('click', '.main-cart .discount-form button', function() {
    let code = $(document).find('.main-cart .discount-form input').val().trim();
    
    if (code) {
        $('.main-cart .el-overlay').show();
        $(document).find('.main-cart .discount-wrapper .discount-message').hide();

        let discountApplyUrl = `/discount/${encodeURIComponent(code)}?redirect=/cart/`;
    
        fetch(discountApplyUrl, {
            method: "GET",
            credentials: "include"
        })
        .then(() => {
            return fetch(`/cart.json`, { method: "GET" });
        })
        .then(response => response.json())
        .then(cartData => {
            let discountTitles = cartData.items
                                .map(item => item.discounts.map(discount => discount.title.toLowerCase()))
                                .flat()
                                .filter(title => title);
            
            if (discountTitles.length > 0) {
                if (discountTitles.includes(code.toLowerCase())) {
                    refreshCart();
                    refreshMainCart();
                } 
                else {
                    $(document).find('.main-cart .discount-wrapper .discount-message').show();
                    $('.main-cart .el-overlay').hide();
                }
            } 
            else {
                $(document).find('.main-cart .discount-wrapper .discount-message').show();
                $('.main-cart .el-overlay').hide();
            }
        })
        .catch(() => {
            $(document).find('.main-cart .discount-wrapper .discount-message').show();
            $('.main-cart .el-overlay').hide();
        });
    }
});

// remove discount in popup
$(document).on('click', '#popup-cart .remove-discount', function() {
    $('#popup-cart .el-overlay').show();
    $('#popup-cart .discount-form input').val('');

    removeDiscount($(this).data('code'));
});

// remove discount in main
$(document).on('click', '.main-cart .remove-discount', function() {
    $('.main-cart .el-overlay').show();
    $('.main-cart .discount-form input').val('');

    removeDiscount($(this).data('code'));
});

$(document).on('click', '.main-cart .cart-checkout a', function() {
    let note = $(document).find('[name="order-note"]').val();

    if (note != '') {
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                note: note
            }),
        })
        .then(response => {
            if (response.ok) {
                window.location.href = '/checkout';
            }
        })
        .catch(error => {
            console.error('Error updating cart note:', error);
        });
    }
    else {
        window.location.href = '/checkout';
    }
});

function removeDiscount(code) {
    const discountToRemove = code

    fetch(`${window.location.origin}/cart.json`)
        .then(response => response.json())
        .then(cartData => {
            let discountTitles = cartData.items
                .map(item => item.discounts.map(discount => discount.title))
                .flat()
                .filter(title => title); // Get applied discount codes

            let remainingDiscounts = discountTitles.filter(title => title !== discountToRemove);

            if (remainingDiscounts.length > 0) {
                remainingDiscounts.forEach(discount => {
                    fetch(`${window.location.origin}/checkout?discount=${discount}`)
                        .finally(function() {
                            refreshCart();
                            refreshMainCart();
                        });
                });
            } else {
                fetch(`${window.location.origin}/checkout?discount=CLEAR`).finally(function() {
                    refreshCart();
                    refreshMainCart();
                });
            }
        })
        .catch(error => console.error("Error fetching cart:", error));
}

$('.ymal-variant').on('change', function() {
    let ymal = $(this).data('ymal');

    let selectedValue = $(this).val();
    let $form = $(`form#${ymal}`);
    $form.find('input[name="id"]').val(selectedValue);
});

//custom collection add to cart {
$(document).on('submit', '.collection-list .atc-form', function (event) {
    event.preventDefault();
    let formData = $(this).serialize();

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function (response) {
            refreshCart();
            refreshMainCart();
            openCart();
        },
        error: function (xhr, status, error) {
            console.error('Error adding product to cart:', error);
        }
    });
});



$(document).on('submit', '.event-page-form', function (event) {
    event.preventDefault();
    let formData = $(this).serialize();

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function (response) {
            refreshCart();
            refreshMainCart();
            openCart();
        },
        error: function (xhr, status, error) {
            console.error('Error adding product to cart:', error);
        }
    });
});